import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import BackAnchor from "../../../../shared/components/BackAnchor";
import OtherGrantQuestions from "../../../../shared/components/OtherGrantQuestions";
import { useLocation } from "react-router-dom";

const NotEligibleView = ({ t, i18n }) => {
  const { search } = useLocation();
  const question = search?.substring(10);
  const { questionDataList } = useSelector((state) => state?.app);
  const payHeat =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 1)
    ].questionAnswer;
  const incomeCheck =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 9)
    ].questionAnswer;
  const incomeAmount =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 16)
    ].questionAnswer;
  const applicantSinCheck =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 11)
    ].questionAnswer;
  const duplicateApplication =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 14)
    ]?.questionAnswer;

  const [eligibilityError, setEligibilityError] = useState(null);
  const [backPath, setBackPath] = useState(null);
  const [backButton, setBackButton] = useState(true);

  useEffect(() => {
    if (payHeat === "No") {
      setEligibilityError(t("not_eligible.not_pay_heat"));
      setBackPath(t("routes.pay_heat"));
    } else if (payHeat === "Yes") {
      if (incomeCheck === "More than $55,000") {
        setEligibilityError(t("not_eligible.income_check_55000"));
      } else if (incomeCheck === "More than $75,000") {
        setEligibilityError(t("not_eligible.income_check_75000"));
      }
      setBackPath(t("routes.net_income_check"));
    } if (applicantSinCheck === "No") {
      setEligibilityError(t("not_eligible.sin_check_fail"));
      setBackPath(t("routes.personal_information"));
      // } else if (applicantSinCheck === "Yes" && spouseSinCheck === "No") {
      //   setEligibilityError(t("not_eligible.sin_check_fail"));
      //   setBackPath(t("routes.another_person"));
    } if (
      // duplicateApplication === "No" ||
      question === "duplicate_application"
    ) {
      setBackButton(false);
      setEligibilityError(t("not_eligible.sin_check_fail"));
    } if (question === "unknown_error") {
      setBackButton(false);
      setEligibilityError(t("not_eligible.unknown_error"));
    }
  }, [
    payHeat,
    duplicateApplication,
    applicantSinCheck,
    incomeAmount,
    incomeCheck,
    question,
    t
  ]);

  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            {backButton && <BackAnchor backPath={backPath} />}

            <div className="row">
              <div className="col-xs-12 " style={{ paddingTop: "1em" }}>
                <div
                  style={{
                    fontSize: "36px",
                    marginBottom: 0,
                    color: "#444444"
                  }}
                >
                  {eligibilityError}
                </div>
              </div>
            </div>
            <OtherGrantQuestions />
            <div className="row">
              <div className="col-xs-12 col-lg-8">
                <h3>{t("confirmation.questions")}</h3>
                <h5>{t("application_status.contact_us")}</h5>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(NotEligibleView);
